import React from "react";
import { Modal, Box, Typography, CircularProgress } from "@mui/material";

const SubmittingModal = ({ loading }) => {
  return (
    <Modal open={loading}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 250,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <CircularProgress size={24} sx={{ mb: 2 }} />
        <Typography variant="body1">Submitting...</Typography>
      </Box>
    </Modal>
  );
};

export default SubmittingModal;
